export default "__VITE_ASSET__BuDUhV8V__"